import { render, staticRenderFns } from "./IconBell.vue?vue&type=template&id=763296a2&scoped=true&"
import script from "./IconBell.vue?vue&type=script&lang=js&"
export * from "./IconBell.vue?vue&type=script&lang=js&"
import style0 from "./IconBell.vue?vue&type=style&index=0&id=763296a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763296a2",
  null
  
)

export default component.exports